import styled from 'styled-components';

export const Container = styled.div`
  color: white;
  text-align: left;
  align-self: center;
`;

export default Container;
